module.exports = __webpack_public_path__ + "img/info-blue.af82a47b.svg";